module.exports = __webpack_public_path__ + "static/img/8.5a0ce7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/8.png
// module id = rgY6
// module chunks = 0